// Response from POST /projects/bulk-create-financial-year (async endpoint)
export interface BulkCreateFinancialYearResponseDto {
    jobId: string;
    status: string;  // Always "pending" initially
    message: string;
}
